import React from 'react';
import * as ChessUtils from './ChessUtils.js';
import * as JsUtils from './JsUtils.js';
import Draggable from 'react-draggable';
import FileUploader from "react-firebase-file-uploader";

import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";

import $ from 'jquery';

const { firebase } = window;
const COLUMNS = 'abcdefghijklmnopqrstuvwx'.split('');
var SQUARE_POSITIONS = {};
var SQUARE_WALLS = {};

// use unique class names to prevent clashing with anything else on the page
// and simplify selectors
const CSS = {
    alpha: 'alpha-d2270',
    black: 'black-3c85d',
    board: 'board-b72b1',
    chessboard: 'chessboard-63f37',
    clearfix: 'clearfix-7da63',
    highlight: 'highlight-square',
    //highlight2: 'highlight2-9c5d2',
    notation: 'notation-322f9',
    numeric: 'numeric-fc462',
    piece: 'piece-417db',
    row: 'row-5277c',
    sparePieces: 'spare-pieces-7492f',
    sparePiecesBottom: 'spare-pieces-bottom-ae20f',
    sparePiecesTop: 'spare-pieces-top-4028b',
    sparePiecesExtra: 'spare-pieces-extra-5123c',
    square: 'square-55d63',
    white: 'white-1e1d7'
};

var cfg = {};

var CURRENT_ORIENTATION,
    CURRENT_POSITION = {},
    SQUARE_SIZE,
    ROWS_COUNT;
  
const EXTRA_PIECE_SIZE = 49;

export default class ChessBoard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
          uploadingPiece: "",
          extraPieces: {},
          lines: '',
        };

        this.getExtraPieces();
    }

    render() {
      CURRENT_POSITION = this.props.board.position;
      if (CURRENT_POSITION === false) {
        CURRENT_POSITION = {};
      }

      CURRENT_ORIENTATION = this.props.board.orientation;      
      if (CURRENT_ORIENTATION !== 'black') {
        CURRENT_ORIENTATION = 'white';
      }

      ROWS_COUNT = this.props.board.boardSize;

      cfg = Object.assign(cfg, this.props);
      
      SQUARE_SIZE = ChessUtils.calculateSquareSize(cfg.boardWidth, ROWS_COUNT);

      var extraDivStyle;
      // Megöli az onClick eventet, nem fog lefutni az overflow miatt
      /*if (Object.keys(this.state.extraPieces).length > 7 ) {
        extraDivStyle = {overflowY: 'scroll'};
      }*/
      var sparePieces= '';
      if (cfg.sparePieces === true) {
        sparePieces = (
          <div id="spare-pieces">
            <div className={CSS.sparePieces + ' ' +
            CSS.sparePiecesTop}>
              {this.buildSparePieces('black')}
            </div>
            <div className={CSS.sparePieces + ' ' +
            CSS.sparePiecesBottom}>
              {this.buildSparePieces('white')}              
            </div>
          </div>
        );
      }

      this.initializeWalls();

      return (
        <div>
          <div className={CSS.sparePieces + ' ' +
            CSS.sparePiecesExtra} style={extraDivStyle}>
            {this.buildExtraPieces()}
          </div>
          <div id="board" style={this.props.boardStyle} onMouseMove={this.onMouseMove.bind(this)}>
            {this.props.watermark}
            {this.buildBoardContainer()}
            {this.drawLines()}
          </div>
          {sparePieces}
        </div>
        )
    }

    componentDidMount() {
      this.init();
      this.updatePositionTable();
    }

    componentDidUpdate() {
      this.init();
      this.updatePositionTable();
    }

    getExtraPieces() {
      firebase.firestore().collection('pieces').where('account_id', '==', this.props.accountId).get().then((querySnapshot) => {
        var extraPieces = this.state.extraPieces;
        querySnapshot.forEach((doc) => {
            var data = doc.data();
            extraPieces[data.piece] = data;
            extraPieces[data.piece].id = doc.id;
        });
        this.setState({ extraPieces: extraPieces })
      });
    }

    updatePositionTable() {
      var squares = document.getElementsByClassName(CSS.square);
      for (var i=0;i<squares.length;i++) {
        var square = squares[i].getAttribute('data-square');
        SQUARE_POSITIONS[square] = this.getOffset(squares[i]);
      }
    }

    getOffset(el) {
      const rect = el.getBoundingClientRect();
      var ret = {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY,
        right: rect.right + window.scrollX,
        bottom: rect.bottom + window.scrollY,
      }
      ret.center = {
        x: (ret.left + ret.right) / 2,
        y: (ret.top + ret.bottom) / 2
      }
      return ret;
    }
 
    // validate config / set default options
    expandConfig() {
        if (typeof cfg === 'string' || ChessUtils.validPositionObject(cfg) === true) {
          cfg = {
            position: cfg
          };
        }
      
        // default for showNotation is true
        if (cfg.showNotation !== false) {
          cfg.showNotation = true;
        }
      
        // default for draggable is false
        if (cfg.draggable !== true) {
          cfg.draggable = false;
        }
            
        // default for sparePieces is false
        if (cfg.sparePieces !== true) {
          cfg.sparePieces = false;
        }
      
        // draggable must be true if sparePieces is enabled
        /*if (cfg.sparePieces === true) {
          cfg.draggable = true;
        } */

        if (!cfg.boardWidth) {
          cfg.boardWidth = 400;
        }
      
        // default piece theme is wikipedia
        if (cfg.hasOwnProperty('pieceTheme') !== true ||
            (typeof cfg.pieceTheme !== 'string' &&
             typeof cfg.pieceTheme !== 'function')) {
          cfg.pieceTheme = 'img/chesspieces/wikipedia/{piece}.png';
        }

        return true;
    }

    //------------------------------------------------------------------------------
    // Markup Building
    //------------------------------------------------------------------------------
    
    buildBoardContainer() {
        return (
          <div className={CSS.chessboard}>
            <div className={CSS.board} id="board_inner">
              {this.buildBoard(CURRENT_ORIENTATION)}
            </div>
          </div>
        );
    }
      
    buildBoard(orientation) {
        if (orientation !== 'black') {
          orientation = 'white';
        }
      
        var html = [];
      
        // algebraic notation / orientation
        var alpha = COLUMNS.slice(0, ROWS_COUNT);
        var row = ROWS_COUNT;
        if (orientation === 'black') {
          alpha.reverse();
          row = 1;
        }

        var highlightStyles = {};
        Object.keys(this.props.highlightStyle).forEach(type => {
          var highlightSize = this.props.highlightStyle[type].size;
          var highlightColor = this.props.highlightStyle[type].color;
          var highlightType, highlightRadius;
          if (this.props.highlightStyle[type].type === 'square') {
            highlightRadius = this.props.highlightStyle[type].radius+'px';
            highlightType = 'inset';
          } else {
            highlightType = '';
            highlightRadius = '50%';
          }
          highlightStyles[type] = {
            boxShadow: `${highlightType} 0 0 0px ${highlightSize}px ${highlightColor}`,
            borderRadius: highlightRadius,
            //zIndex: 1
          }
        })

        var indexStyles = {};
        Object.keys(this.props.indexStyle).forEach(type => {
          let indexSize = this.props.indexStyle[type].size;
          let indexColor = this.props.indexStyle[type].color;
          let indexType, indexRadius;
          if (this.props.indexStyle[type].type === 'square') {
            indexRadius = this.props.indexStyle[type].radius+'px';
            indexType = 'inset';
          } else {
            indexType = '';
            indexRadius = '50%';
          }
          indexStyles[type] = {
            boxShadow: `${indexType} 0 0 0px ${indexSize}px ${indexColor}`,
            borderRadius: indexRadius,
            //zIndex: 1
          }
        })

        var squareColor = 'white', hlType, layerType, layerStyle;
        for (var i = 0; i < ROWS_COUNT; i++) {
          var squareHtml = [];
          for (var j = 0; j < ROWS_COUNT; j++) {
            var square = alpha[j] + row;
      
            var alphaNotation = '', numericNotation = '';
            if (cfg.showNotation === true && SQUARE_SIZE && this.props.notation.type !== 'none') {
              var notationStyleAlpha = {
                left: '0px',
                height: SQUARE_SIZE+'px',
                width: SQUARE_SIZE+'px',
              };
              var notationStyleNumeric = {
                fontSize: this.props.notation.fontSize+'px',
                fontFamily: this.props.availableFontFamilys[this.props.notation.fontFamily].family,
                lineHeight: SQUARE_SIZE+'px',
                color: this.props.notation.color,
                height: SQUARE_SIZE+'px',
                width: SQUARE_SIZE+'px',
                left: -1*Math.max(SQUARE_SIZE*1.35, 20)+'px',
                top: '0px',
                textAlign: 'right'
              }
              var alphaNotationFigure = alpha[j];
              var numericNotationFigure = row;
              if (
                this.props.notation.type === 'color' ||
                this.props.notation.type === 'black'                
              ) {
                alphaNotationFigure = <img alt="" src={this.props.availableCoordinateThemes[this.props.notation.type][j]} style={{width: '65%', height: '65%'}} />
                notationStyleAlpha.top = (SQUARE_SIZE+10)+'px';
              } else {
                notationStyleAlpha = Object.assign(notationStyleAlpha, {
                  color: this.props.notation.color,
                  fontSize: this.props.notation.fontSize+'px',
                  fontFamily: this.props.availableFontFamilys[this.props.notation.fontFamily].family,
                  lineHeight: SQUARE_SIZE+'px',
                  top: Math.max(SQUARE_SIZE+1, 20)+'px',                    
                });
              }

              if (this.props.notation.type === 'capital') {
                notationStyleAlpha.textTransform = 'capitalize';
                notationStyleNumeric.textTransform = 'capitalize';
              }
                // alpha notation
              if ((orientation === 'white' && row === 1) ||
                  (orientation === 'black' && row === 8)) {
                alphaNotation = (
                  <div className={CSS.notation + ' ' + CSS.alpha} style={notationStyleAlpha}>
                    {alphaNotationFigure}
                  </div>
                );
              }
      
              // numeric notation
              if (j === 0) {
                numericNotation = (
                  <div className={CSS.notation + ' ' + CSS.numeric} style={notationStyleNumeric}>
                    {numericNotationFigure}
                  </div>
                );
              }
            }
            let style = {
              width: SQUARE_SIZE+'px',
              height: SQUARE_SIZE+'px',
              background: this.props.board.boardColors[squareColor],
            };
            if (squareColor === 'black') {
              var white = this.props.board.boardColors.white;
              var black = this.props.board.boardColors.black;
              switch (this.props.board.boardPattern) {
                case 'striped':
                // Striped
                  style.background = `repeating-linear-gradient(-45deg, ${white}, ${white} 3px, ${black} 3px, ${black} 6px)`;
                  break;
                
                case 'dotted':
                  // Dotted
                  style.background =
                  `radial-gradient(black 15%, ${black} 16%) 0px 0px,`+
                  `radial-gradient(black 15%, ${black} 16%) 12px 12px`;
                  style.backgroundSize = '16px 16px';
                  break;

                case 'Stairs':
                  // Stairs
                  style.background = 
                    `linear-gradient(63deg, ${white} 23%, transparent 23%) 3px 0,`+
                    `linear-gradient(63deg, transparent 74%, ${white} 78%),`+
                    `linear-gradient(63deg, transparent 34%, ${white} 38%, ${white} 58%, transparent 62%),`+
                    this.props.board.boardColors.black;
                  style.backgroundSize = '8px 24px';
                  break;

                case 'Pyramid':
                  // Pyramid
                  var blackRgb = ChessUtils.hexToRgb(this.props.board.boardColors.black);
                  var northBlack = 'rgb('+(blackRgb.r+100)+', '+(blackRgb.g+100)+', '+(blackRgb.b+100)+')';
                  var westBlack = 'rgb('+(blackRgb.r+25)+', '+(blackRgb.g+25)+', '+(blackRgb.b+25)+')';
                  var southBlack = 'rgb('+(blackRgb.r-25)+', '+(blackRgb.g-25)+', '+(blackRgb.b-25)+')';
                  var eastBlack = 'rgb('+(blackRgb.r-75)+', '+(blackRgb.g-75)+', '+(blackRgb.b-75)+')';
                  style.background =
                    `linear-gradient(315deg, transparent 75%, ${northBlack} 0) -12px 0 / 24px 24px,`+
                    `linear-gradient(45deg, transparent 75%, ${northBlack} 0) -12px 0 / 24px 24px,`+
                    `linear-gradient(135deg, ${westBlack} 50%, transparent 0) 0 0 / 24px 24px,`+
                    `linear-gradient(45deg, ${southBlack} 50%, transparent 0) 0 0 / 24px 24px `+
                    eastBlack;
                  break;
                
                default:
                  break;
              }
            }
            if (this.props.board.boardPattern === 'Wooden') {
              style.background = 'url(/chessboardjs/img/wood_tile_'+squareColor+'.png) -'+Math.floor(Math.random() * 100)+'px -'+Math.floor(Math.random() * 100)+'px no-repeat';
            }
            if (this.props.board.boardPattern === 'Wooden2') {
              style.background = 'url(/chessboardjs/img/wood_tile_'+squareColor+'2.png) 0 0 no-repeat';
            }
            if (this.props.board.boardPattern === 'Paper') {
              style.background = 'url(/chessboardjs/img/paper_tile_'+squareColor+'.png) -'+Math.floor(Math.random() * 100)+'px -'+Math.floor(Math.random() * 100)+'px no-repeat';
            }
            if (this.props.board.boardPattern === 'Textile') {
              style.background = 'url(/chessboardjs/img/textil_tile_'+squareColor+'.png) -'+Math.floor(Math.random() * 100)+'px -'+Math.floor(Math.random() * 100)+'px no-repeat';
            }
            if (this.props.board.boardPattern === 'Metal') {
              style.background = 'url(/chessboardjs/img/metal_tile_'+squareColor+'.png) -'+Math.floor(Math.random() * 50)+'px -'+Math.floor(Math.random() * 50)+'px / 100px 100px no-repeat';
            }

            var className = [
              CSS.square,
              'square-' + square
            ]

            hlType = this.props.highlights[square];
            if (hlType) {
              style = Object.assign(style, highlightStyles[hlType]);
            }

            var indexes = [];
            if (this.props.indexes[square]) {
              for (let location in this.props.indexes[square]) {
                let indxType = this.props.indexes[square][location].mode;
                let indxStyle = this.props.indexStyle[indxType];
                if (indxType) {
                  let indexStyle = JsUtils.deepCopy(indexStyles[indxType]);
                  indexStyle.top = location.indexOf('bottom') === 0 ? '50%' : 0;
                  indexStyle.left = location.indexOf('right') >= 0 ? '50%': 0
                  indexStyle.color = indxStyle.color;
                  indexes.push(
                    <div key={location} id={"square-index-"+square+"-"+location} className="square-index" style={ indexStyle }>{ this.props.indexes[square][location].index }</div>
                  )
                }
              }
            }

            if (SQUARE_WALLS[square]) {
              for (let direction in SQUARE_WALLS[square]) {
                if (SQUARE_WALLS[square].hasOwnProperty(direction)) {
                  if (!style.border) {
                    style['border' + this.ucFirstLetter(direction)] = SQUARE_WALLS[square][direction];
                    style.boxSizing = 'border-box';
                  }
                }
              }
            }
    
            var piece = '';
            if (CURRENT_POSITION.hasOwnProperty(square)) {
              piece = this.buildPieceReact(CURRENT_POSITION[square], false, square, style, SQUARE_SIZE);
            }

            var layer = '';
            layerType = this.props.layers[square];
            if (layerType) {
              layerStyle = {
                height: SQUARE_SIZE+'px',
                width: SQUARE_SIZE+'px',                
                backgroundColor: this.props.layerStyle[layerType].backgroundColor,
                opacity: this.props.layerStyle[layerType].opacity,
                position: 'absolute',
              }
              layer = (
                <div className="cellLayer" style={ layerStyle }></div>
              )
            }

            squareHtml.push(
              <div
              key={j}
              className={className.join(' ')}
              style={style}
              onMouseEnter={this.mouseenterSquare.bind(this)}
              onMouseLeave={this.mouseleaveSquare.bind(this)}
              onMouseDown={this.mouseDownSquare.bind(this)}
              onMouseUp={this.mouseUpSquare.bind(this)}
              onClick={this.onClickSquare.bind(this)}
              onDoubleClick={this.props.dblClickOnSquare.bind(this, square)}
              data-square={square}>
                <div className="square_bg" style={style}></div>
                {alphaNotation}
                {numericNotation}
                {layer}
                {indexes}
                {piece}
              </div>
            );
      
            squareColor = (squareColor === 'white' ? 'black' : 'white');
          }

          html.push(
            <div key={i} className={CSS.row}>
              {squareHtml}
              <div className={CSS.clearfix}></div>
            </div>
          );
      
          squareColor = (squareColor === 'white' ? 'black' : 'white');
      
          if (orientation === 'white') {
            row--;
          }
          else {
            row++;
          }
        }
      
        return html;
    }
      
    buildPieceImgSrc(piece) {
        if (typeof cfg.pieceTheme === 'function') {
          return cfg.pieceTheme(piece);
        }
      
        if (typeof cfg.pieceTheme === 'string') {
          return cfg.pieceTheme.replace(/{piece}/g, piece);
        }
      
        return '';
    }
      
    buildPieceReact(piece, hidden, square, squareStyle = {}, piece_size) {
      var id = 'piece-'+square+'-'+piece;

      var style;
      if (square === 'spare') {
         style = {
          width: piece_size + 'px',
          height: piece_size + 'px',
        }
      } else if (this.props.board.pieceSize === 'full') {
        style = {
          position: 'absolute',
          bottom: 5,
          left: 0,
        }
      } else {
        style = {
          maxWidth: this.props.board.pieceSize + '%',
          maxHeight: this.props.board.pieceSize + '%',
          padding: (100-this.props.board.pieceSize)/2 + '% 0',
        }
      }
      if (hidden === true) {
        style.display = 'none';
      }
      if (cfg.draggable === true) {
        style.cursor = 'grab';
        style.cursor = '-webkit-grab';
      }
      var arrowsStart = this.props.arrows.filter(arrow => (arrow.start === square));
      var arrowsEnd = this.props.arrows.filter(arrow => (arrow.end === square));
      // TODO
      /*if (
        (arrowsStart.length > 0 && this.props.arrowStyle.type === 'normal') ||
        (arrowsStart.length > 0 && arrowsEnd.length === 0 && this.props.arrowStyle.type === 'horse')
      ) {
        style.zIndex = 1002;
      }*/
      if (arrowsStart.length > 0) {
        if (
          arrowsEnd.length
          && this.props.arrowStyle[arrowsStart[0].type].type === 'horse'
          && this.props.arrowStyle[arrowsEnd[0].type].type === 'horse'
        ) {
          // Ló nyíl közepén a bábun menjen át a nyíl ha kell
        } else {
          style.zIndex = 1002;
        }
      }

      var simpleclick;
      if (square === 'spare') {
        simpleclick = this.props.enableMultiAddMode.bind(this, {figure: piece});
      }
      
      var borderStyle = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
      }
      if (squareStyle.borderLeft) {
        borderStyle.left = parseInt(squareStyle.borderLeft, 10);
      }
      if (squareStyle.borderRight) {
        borderStyle.right = parseInt(squareStyle.borderRight, 10);
      }
      if (squareStyle.borderTop) {
        borderStyle.top = parseInt(squareStyle.borderTop, 10);
      }
      if (squareStyle.borderBottom) {
        borderStyle.bottom = parseInt(squareStyle.borderBottom, 10);
      }
      var extraMargin = 0;
      var img;
      if (
        (piece in this.state.extraPieces)
      ) {
        img = this.state.extraPieces[piece].url;
        extraMargin = 10-this.props.board.extraPieceSize;
        style.width = (piece_size-2*extraMargin) + 'px';
        style.height = (piece_size-2*extraMargin) + 'px';
      } else if (ChessUtils.validPieceCode(piece)) {
        img = this.buildPieceImgSrc(piece);
        style.width = piece_size + 'px';
        style.height = piece_size + 'px';
      } else {
        return '';
      }
      style.marginLeft = (extraMargin-borderStyle.left) + 'px';
      style.marginRight = (extraMargin-borderStyle.right) + 'px';
      style.marginTop = (extraMargin-borderStyle.top) + 'px';
      style.marginBottom = (extraMargin-borderStyle.bottom) + 'px';
      //style.maxWidth = 'none';

      return (
        <Draggable
        position={{x: 0, y: 0}}
        onStart={this.handleDragStart.bind(this)}
        onDrag={this.handleDrag.bind(this)}
        onStop={this.handleDragStop.bind(this)}
        key={id}
        >
        <img src={img}
          key={id}
          id={id}
          alt=""
          className={CSS.piece}
          onDoubleClick={(e) => {this.removePiece(square, e)}}
          onClick={simpleclick}
          data-piece={piece}
          data-position={square}
          style={style}
        />
        </Draggable>
      )
    }

    buildUniquePiece(piece, url, piece_size) {
      var square = 'spare';
      var id = 'extra-piece-'+piece;
      var style = {
        width: piece_size + 'px',
        height: piece_size + 'px',
        zIndex: 10001
      }
      if (cfg.draggable === true) {
        style.cursor = 'grab';
        style.cursor = '-webkit-grab';
      }
      var simpleclick = this.props.enableMultiAddMode.bind(this, {figure: piece, url: url});
      
      return (
        <Draggable
        position={{x: 0, y: 0}}
        onStart={this.handleDragStart.bind(this)}
        onDrag={this.handleDrag.bind(this)}
        onStop={this.handleDragStop.bind(this)}
        key={id}
        >
        <img src={url}
          key={id}
          id={id}
          alt=""
          className={CSS.piece}
          onClick={simpleclick}
          data-piece={piece}
          data-position={square}
          style={style}
        />
        </Draggable>
      )
    }
      
    buildSparePieces(color) {
        var pieces = ['wK', 'wQ', 'wR', 'wB', 'wN', 'wP'];
        if (color === 'black') {
          pieces = ['bK', 'bQ', 'bR', 'bB', 'bN', 'bP'];
        }
      
        var html = [], tmp;
        for (var i = 0; i < pieces.length; i++) {
          tmp = (
            <div key={i} style={{border: "1px solid #cccccc", position: 'relative', height: EXTRA_PIECE_SIZE+'px', width: EXTRA_PIECE_SIZE+'px'}}>
              {this.buildPieceReact(pieces[i], false, 'spare', {}, EXTRA_PIECE_SIZE)}
            </div>
          )
          html.push(tmp);
        }
      
        return html;
    }

    buildExtraPieces() {
      var html = [], lastPieceNumber;

      function alphanumericalsort(a,b) {
        var i = a.substring(1);
        var j = b.substring(1);
        if (parseInt(i, 10) < parseInt(j, 10)) {
          return -1;
        } else {
          return 1;
        }
      }
      
      Object.keys(this.state.extraPieces).sort(alphanumericalsort).forEach((extraPiece) => {
        lastPieceNumber = extraPiece.substring(1);
        html.push(
          <div key={'extra_'+extraPiece}>
          <ContextMenuTrigger id={'extra_menu_'+extraPiece}>
          <div style={{border: "1px solid #cccccc", height: EXTRA_PIECE_SIZE+'px', width: EXTRA_PIECE_SIZE+'px'}}>
            {this.buildUniquePiece(extraPiece, this.state.extraPieces[extraPiece].url, EXTRA_PIECE_SIZE)}
          </div>
          </ContextMenuTrigger>

          <ContextMenu id={'extra_menu_'+extraPiece}>
            <MenuItem data={{action: 'deleteExtraImage', extraPiece: extraPiece}} onClick={this.handleRightClick.bind(this)}>
              {this.props.strings.deleteImage}
            </MenuItem>
          </ContextMenu>
          </div>
        )
      });
      var nextExtraPiece = 'e1';
      if (lastPieceNumber) {
        nextExtraPiece = 'e' + ++lastPieceNumber;
      }
      html.push(
        <div key={'extra'+nextExtraPiece} style={{height: SQUARE_SIZE+'px', width: SQUARE_SIZE+'px', fontSize: "30px"}}>
          {this.getFileUploader(nextExtraPiece)}
        </div>
      )
      return html;
    }

    handleRightClick(e, data) {
      if (data.action === 'deleteExtraImage') {
        // Create a reference to the file to delete
        var imageRef = firebase.storage().ref("pieces")
          .child(this.state.extraPieces[data.extraPiece].filename);

        // Delete the file
        imageRef.delete().then(() => {
          // File deleted successfully
          firebase.firestore().collection('pieces')
            .doc(this.state.extraPieces[data.extraPiece].id).delete()
          .then(() => {
            var extraPieces = this.state.extraPieces;
            delete extraPieces[data.extraPiece];
            this.setState({ extraPieces: extraPieces });
            this.removePieceFromBoard(data.extraPiece);
          }).catch(function(error) {
            console.error("Error removing document: ", error);
          });
        }).catch(function(error) {
          // Uh-oh, an error occurred!
        });
      }
    }

    removePieceFromBoard(piece) {
      var newPosition = JsUtils.deepCopy(CURRENT_POSITION);

      for (var square in newPosition) {
        if (newPosition[square] === piece) {
          delete newPosition[square];
        }
      }

      this.props.updatePosition(newPosition);
    }

    handleUploadError = error => {
      console.error(error);
    }
    handleUploadSuccess = (filename) => {
      firebase
        .storage()
        .ref("pieces")
        .child(filename)
        .getDownloadURL()
        .then(url => {
          firebase.firestore().collection('pieces').add({
            account_id: this.props.accountId,
            filename: filename,
            piece: this.state.uploadingPiece,
            url: url
          });
          this.getExtraPieces();
        });
    }
    handleUpload = (event) => {
      const { target: { files } } = event;
      this.setState({ uploadingPiece: event.target.getAttribute('name') });
  
      for (var i = 0; i < files.length; i++) {
        this.fileUploader.startUpload(files[i]);
      }
    }
    
    getFileUploader(name) {
      return (
        <form>
          <label style={{backgroundColor: 'steelblue', color: 'white', padding: 10, borderRadius: 4, cursor: 'pointer'}}>
          +
            <FileUploader
              hidden
              accept="*"
              name={name}
              onChange={this.handleUpload}
              randomizeFilename
              storageRef={firebase.storage().ref("pieces")}
              onUploadError={this.handleUploadError}
              onUploadSuccess={this.handleUploadSuccess}
              maxWidth="200"
              maxHeight="200"
              ref={instance => { this.fileUploader = instance; } } 
            />
          </label>
        </form>        
      )
    }
    //------------------------------------------------------------------------------
    // Browser Events
    //------------------------------------------------------------------------------
                  
    mouseenterSquare(e) {
        if (!this.props.highLightMode && !this.props.arrowMode && !this.props.layerMode && !this.props.indexMode) return;
      
        if (this.props.hasOwnProperty('onMouseoverSquare') !== true ||
          typeof this.props.onMouseoverSquare !== 'function') return;
      
        // get the square
        var square = e.currentTarget.getAttribute('data-square');
      
        // NOTE: this should never happen; defensive
        if (ChessUtils.validSquare(square) !== true) return;
      
        // get the piece on this square
        var piece = false;
        if (CURRENT_POSITION.hasOwnProperty(square) === true) {
          piece = CURRENT_POSITION[square];
        }
      
        // execute their function
        this.props.onMouseoverSquare(square, piece, JsUtils.deepCopy(CURRENT_POSITION),
          CURRENT_ORIENTATION);
    }
      
    mouseleaveSquare(e) {
        if (!this.props.highLightMode && !this.props.arrowMode && !this.props.multiAddPiece && !this.props.wallMode && !this.props.layerMode && !this.props.indexMode) return;
      
        if (this.props.hasOwnProperty('onMouseoutSquare') !== true ||
          typeof this.props.onMouseoutSquare !== 'function') return;
      
        // get the square
        var square = e.currentTarget.getAttribute('data-square');

        //console.log('leavesquare '+square);
        $('.square-55d63').css('z-index', '');

        // NOTE: this should never happen; defensive
        if (ChessUtils.validSquare(square) !== true) return;
      
        // get the piece on this square
        var piece = false;
        if (CURRENT_POSITION.hasOwnProperty(square) === true) {
          piece = CURRENT_POSITION[square];
        }
      
        // execute their function
        this.props.onMouseoutSquare(square, piece, JsUtils.deepCopy(CURRENT_POSITION),
          CURRENT_ORIENTATION);
    }

    mouseDownSquare(e) {
      if (this.props.hasOwnProperty('onMouseDownSquare') !== true ||
      typeof this.props.onMouseDownSquare !== 'function') return;
  
      var square = e.currentTarget.getAttribute('data-square');
    
      // NOTE: this should never happen; defensive
      if (ChessUtils.validSquare(square) !== true) return;
    
      // get the piece on this square
      var piece = false;
      if (CURRENT_POSITION.hasOwnProperty(square) === true) {
        piece = CURRENT_POSITION[square];
      }
    
      // execute their function
      this.props.onMouseDownSquare(square, piece);
    }

    mouseUpSquare(e) {
      if (this.props.hasOwnProperty('onMouseUpSquare') !== true ||
      typeof this.props.onMouseUpSquare !== 'function') return;
  
      var square = e.currentTarget.getAttribute('data-square');
    
      // NOTE: this should never happen; defensive
      if (ChessUtils.validSquare(square) !== true) return;
    
      // get the piece on this square
      var piece = false;
      if (CURRENT_POSITION.hasOwnProperty(square) === true) {
        piece = CURRENT_POSITION[square];
      }
    
      // execute their function
      this.props.onMouseUpSquare(square, piece);
    }    

    onClickSquare(e) {
      var square = {};

      var squareHtml = e.target;
      if (
        squareHtml.tagName === 'IMG'
        || squareHtml.className.indexOf('cellLayer') !== -1
        || squareHtml.className.indexOf('square-index') !== -1
        || squareHtml.className.indexOf('square-index-test') !== -1
        || squareHtml.className.indexOf('square_bg') !== -1
      ) {
          squareHtml = squareHtml.parentElement;
      }
      square.cell = squareHtml.getAttribute('data-square');
      var coords = {
        center: {
          x: e.pageX,
          y: e.pageY,
        }
      }

      if (this.props.wallMode) {
        square.nearestBorder = this.nearestBorder(coords, square.cell);
        var neighbour = this.nearestNeighbour(square.cell, square.nearestBorder);
        if (!neighbour) {
          return;
        }
        square.wall = [square.cell, neighbour].sort().join('-');

        //square.wall = square.cell+'-'+this.nearestNeighbour(square.cell, square.nearestBorder);
        //square.nearestNeighbour = this.nearestNeighbour(square.cell, square.nearestBorder);
      }

      if (this.props.indexMode) {
        let position = this.locateSquarePosition(coords, square.cell);
        square.position = '';
        square.position += position.top
          ? 'top'
          : 'bottom';
        square.position += position.left
          ? 'left'
          : 'right';
      }
      this.props.onClickSquare(square);
    }

    //------------------------------------------------------------------------------
    // Initialization
    //------------------------------------------------------------------------------
      
    init() {
      if (this.expandConfig() !== true) return;
        
      // set board width
      var boardEl = document.getElementById('board_inner');
      boardEl.style.width = (SQUARE_SIZE * ROWS_COUNT) + 'px';
      // update squares size
      var squares = document.getElementsByClassName(CSS.square);
      for (var i=0;i<squares.length;i++) {
        squares[i].style.width = SQUARE_SIZE + 'px';
        squares[i].style.height = SQUARE_SIZE + 'px';
      }
    }

    coordsToPosition(coords) {
      for (var key in SQUARE_POSITIONS) {
        if (SQUARE_POSITIONS.hasOwnProperty(key)) {
          var square = SQUARE_POSITIONS[key];
          if (
            coords.center.x >= square.left &&
            coords.center.x < square.right &&
            coords.center.y >= square.top &&
            coords.center.y < square.bottom 
          ) {
            return key;
          }
        }
      }
      return null;
    }

    nearestBorder(coords, square) {
      var squareCoords = SQUARE_POSITIONS[square];
      var distance = [
        Math.abs(squareCoords.top - coords.center.y),
        Math.abs(squareCoords.right - coords.center.x),
        Math.abs(squareCoords.bottom - coords.center.y),
        Math.abs(squareCoords.left - coords.center.x),
      ]
      switch(distance.indexOf(Math.min.apply(null, distance))) {
        case 0: return 'top';
        case 1: return 'right';
        case 2: return 'bottom';
        case 3: default: return 'left';
      }
    }

    locateSquarePosition(coords, square) {
      var squareCoords = SQUARE_POSITIONS[square];
      
      var ret = {
        top: false,
        bottom: false,
        left: false,
        right: false,
      };

      if (Math.abs(squareCoords.top - coords.center.y) < Math.abs(squareCoords.bottom - coords.center.y)) {
        ret.top = true;
      } else {
        ret.bottom = true;
      }
      if (Math.abs(squareCoords.left - coords.center.x) < Math.abs(squareCoords.right - coords.center.x)) {
        ret.left = true;
      } else {
        ret.right = true;
      }

      return ret;
    }

    nearestNeighbour(square, direction) {
      var [squareLetter, squareNumber] = ChessUtils.parseSquare(square);
      switch(direction) {
        case 'left':
          if (COLUMNS.indexOf(squareLetter) === 0) return false;
          return COLUMNS[COLUMNS.indexOf(squareLetter)-1] + squareNumber;
        case 'right':
          if (COLUMNS.indexOf(squareLetter) === 7) return false;
          return COLUMNS[COLUMNS.indexOf(squareLetter)+1] + squareNumber;
        case 'top':
          if (squareNumber === 8) return false;
          return squareLetter + (squareNumber+1);
        case 'bottom':
        default:
          if (squareNumber === 1) return false;
          return squareLetter + (squareNumber-1);
      }
    }
  
    handleDrag(evt, drag) { }
  
    handleDragStart(evt, drag) {
      evt.preventDefault()
  
      if (cfg.draggable !== true) {
        return false
      }
      return evt
    }
  
    handleDragStop(evt, drag) {
      const node = drag.node;
      const dragToPosition = this.getOffset(node);
      const dragTo = this.coordsToPosition(dragToPosition);
      const dragFrom = drag.node.getAttribute('data-position');
      const draggingPiece = drag.node.getAttribute('data-piece');

      if (
        dragFrom === dragTo
        || (dragFrom === 'spare' && dragTo === null)
      ) {
        return true;
      }
      var newPosition = JsUtils.deepCopy(CURRENT_POSITION);
      newPosition[dragTo] = draggingPiece;
      if (dragFrom !== 'spare') {
        delete newPosition[dragFrom];
      }
      this.props.updatePosition(newPosition);
      if (dragFrom !== 'spare') {
        return false;
      } else {
        return true;
      }
    }
  
    removePiece(square, e) {
      if (square === 'spare') return;
      var newPosition = JsUtils.deepCopy(CURRENT_POSITION);
      delete newPosition[square];
      this.props.updatePosition(newPosition);
      e.stopPropagation();
    }
     
    drawLines() {
      if (Object.keys(SQUARE_POSITIONS).length === 0) {
        return;
      }
      var boardEl = document.getElementById('board');
      var boardOffset = this.getOffset(boardEl);
      var html = [];
      for (var i=0;i<this.props.arrows.length;i++)
      {
        var fromPos = SQUARE_POSITIONS[this.props.arrows[i].start];
        var toPos = SQUARE_POSITIONS[this.props.arrows[i].end];
        var fromPoint = {
          x: fromPos.center.x-boardOffset.left,
          y: fromPos.center.y-boardOffset.top,
        }
        var toPoint = {
          x: toPos.center.x-boardOffset.left,
          y: toPos.center.y-boardOffset.top,
        }
        var lastLine = this.props.arrows.find(o => o.start === this.props.arrows[i].end)
            ? false
            : true;
        html.push(
          this.createLine(i, fromPoint.x, fromPoint.y, toPoint.x, toPoint.y, this.props.arrows[i].type, lastLine)
        )
      }
      return html;
    }

    isFigureOnSquare(square) {
      return CURRENT_POSITION[square]
        ? true
        : false;
    }

    createLine(id, x1,y1, x2,y2, version, lastLine) {
      var aStyle = this.props.arrowStyle[version];
      var arrowType = aStyle.type;
      var headlen = 5 * aStyle.headSize;
      var figureOnSquare = this.isFigureOnSquare(this.props.arrows[id].end);
      var width, height, top, left, extraSpace, curveSpace, controlX, controlY, headAngle, arrowHead, arrowHeadPolygon, svgInner;

      if (arrowType === "curved-top") {
        curveSpace = 100;
        extraSpace = Math.ceil(headlen/2)*2;
        width = Math.abs(x1-x2) + extraSpace;
        height = Math.abs(y1-y2) + curveSpace;
        top = Math.min(y1,y2) - curveSpace;
        left = Math.min(x1,x2) - extraSpace/2;
      } else if (arrowType === "curved-bottom") {
        curveSpace = 100;
        extraSpace = Math.ceil(headlen/2)*2;
        width = Math.abs(x1-x2) + extraSpace;
        height = Math.abs(y1-y2) + curveSpace;
        top = Math.min(y1,y2);
        left = Math.min(x1,x2) - extraSpace/2;
      } else if (arrowType === "curved-left" || arrowType === "curved-right") {
        curveSpace = 200;
        extraSpace = Math.ceil(headlen/2)*2;
        width = Math.abs(x1-x2) + curveSpace;
        height = Math.abs(y1-y2) + extraSpace;
        top = Math.min(y1,y2) - extraSpace;
        left = Math.min(x1,x2) - curveSpace/2;
      } else {
        extraSpace = Math.ceil(headlen/2)*2;
        height = Math.abs(y1-y2) + extraSpace;
        width = Math.abs(x1-x2) + extraSpace;
        top = Math.min(y1,y2) - extraSpace/2;
        left = Math.min(x1,x2) - extraSpace/2;
      }
      var angle  = Math.atan2(y2 - y1, x2 - x1);

      x1 = x1-left;
      x2 = x2-left;
      y1 = y1-top;
      y2 = y2-top;

      if (
        arrowType === "curved-top"
        || arrowType === "curved-bottom"
        || arrowType === "curved-left"
        || arrowType === "curved-right"
      ) {
        [angle, controlX, controlY, headAngle] = this.calculateCurveParams(width, height, curveSpace, x1, x2, y1, y2, arrowType);
      }

      if (
        (arrowType === "normal" && figureOnSquare) ||
        (arrowType === "horse" && lastLine && figureOnSquare)
      ) {
        x2 -= Math.cos(angle)*20;
        y2 -= Math.sin(angle)*20;
      } else if (
        (arrowType === "curved-top" || arrowType === "curved-bottom" || arrowType === "curved-left" || arrowType === "curved-right")
        && figureOnSquare
      ) {
        x2 -= Math.cos(headAngle)*20;
        y2 -= Math.sin(headAngle)*20;
        [angle, controlX, controlY, headAngle] = this.calculateCurveParams(width, height, curveSpace, x1, x2, y1, y2, arrowType);
      }
      
      if (
        arrowType === "normal" ||
        (arrowType === "horse" && lastLine)
      ) {
          arrowHead = [
              x2+','+y2,
              (x2-headlen*Math.cos(angle-Math.PI/6))+','+(y2-headlen*Math.sin(angle-Math.PI/6)),
              (x2-headlen*Math.cos(angle+Math.PI/6))+','+(y2-headlen*Math.sin(angle+Math.PI/6))
          ];

          x2 -= Math.cos(angle)*8;
          y2 -= Math.sin(angle)*8;
      } else if (
        arrowType === "curved-top" ||
        arrowType === "curved-bottom" ||
        arrowType === "curved-left" ||
        arrowType === "curved-right"
      ) {
        arrowHead = [
          x2+','+y2,
          (x2-headlen*Math.cos(headAngle-Math.PI/6))+','+(y2-headlen*Math.sin(headAngle-Math.PI/6)),
          (x2-headlen*Math.cos(headAngle+Math.PI/6))+','+(y2-headlen*Math.sin(headAngle+Math.PI/6))
        ];

        x2 -= Math.cos(headAngle)*8;
        y2 -= Math.sin(headAngle)*8;
        [angle, controlX, controlY, headAngle] = this.calculateCurveParams(width, height, curveSpace, x1, x2, y1, y2, arrowType);
      }
      if (arrowHead) {
        arrowHeadPolygon = <polygon points={arrowHead.join(' ')} style={{
          fill: aStyle.headColor,
          stroke: aStyle.headOutlineColor,
          strokeWidth: 1
        }} />
      }
      var zIndex = aStyle.location === 'over'
        ? 1001
        : 998;

      if (
        arrowType === "normal" ||
        arrowType === "horse"
      ) {
        svgInner = (
          <line x1={x1} y1={y1} x2={x2} y2={y2} style={{
            stroke: aStyle.lineColor,
            strokeDasharray: aStyle.dash,
            strokeWidth: aStyle.lineSize,
          }} />
        )
      } else {
        var d = `M${x1} ${y1} Q ${controlX} ${controlY} ${x2} ${y2}`;
        svgInner = (
          <path d={d} style={{
            stroke: aStyle.lineColor,
            strokeDasharray: aStyle.dash,
            strokeWidth: aStyle.lineSize,
          }} fill="transparent"/>
        )
      }

      return (
        <svg
            className="board_arrow"
            key={Math.random().toString(36).substring(7)}
            onDoubleClick={this.props.removeArrow.bind(this, id)}
            onMouseDown={(e) => {e.preventDefault(); }} // Fix: don't select any element
            style={{
              height: height,
              width: width,
              position: 'absolute',
              top: top,
              left: left,
              zIndex: zIndex,
              fillOpacity: parseInt(aStyle.opacity,10)/10,
              strokeOpacity: parseInt(aStyle.opacity,10)/10,
            }}>
          {svgInner}
          {arrowHeadPolygon}
        </svg>
      )
  }

  onMouseMove(e) {
    // TODO - ez miért kellett ide?
    //$('.piece-417db').css('z-index', 1001);

    var coords = {
      center: {
        x: e.pageX,
        y: e.pageY,
      }
    }

    if (this.coordsToPosition(coords) !== null) {
      var square = this.coordsToPosition(coords);
      if (this.props.wallMode) {
        var nearestBorder = this.nearestBorder(coords, square);
        this.props.previewWall(square, nearestBorder);
      }
      if (this.props.indexMode) {
        let squareLocation = this.locateSquarePosition(coords, square);
        this.props.previewIndex(square, squareLocation);
      }
      if (!this.props.highLightMode && !this.props.arrowMode && !this.props.multiAddPiece && !this.props.wallMode && !this.props.layerMode && !this.props.indexMode) return;
      $('.square-'+square).css('z-index', 2000);
    }
  }

  ucFirstLetter(str) 
  {
      return str.charAt(0).toUpperCase() + str.slice(1);
  }
  oppositeDirection(dir)
  {
    switch(dir) {
      case 'top':
        return 'bottom';
      case 'bottom':
        return 'top';
      case 'left':
        return 'right';
      case 'right':
      default:
        return 'left';
    }
  }
  determineDirection(cell1, cell2) {
    var [squareLetter1, squareNumber1] = ChessUtils.parseSquare(cell1);
    var [squareLetter2, squareNumber2] = ChessUtils.parseSquare(cell2);
    if (squareLetter1 === squareLetter2) {
      if (squareNumber1 > squareNumber2) {
        return 'bottom';
      } else {
        return 'top';
      }
    } else {
      if (COLUMNS.indexOf(squareLetter1) > COLUMNS.indexOf(squareLetter2)) {
        return 'left';
      } else {
        return 'right';
      }
    }
  }

  getNeighbourSquares(square) {
    var [squareLetter, squareNumber] = ChessUtils.parseSquare(square);
    var neighbours = [];
    
    if (COLUMNS.indexOf(squareLetter) > 0) {
      neighbours.push({cell: COLUMNS[COLUMNS.indexOf(squareLetter)-1] + squareNumber, direction: 'left'});
    }
    if (COLUMNS.indexOf(squareLetter) < 8) {
      neighbours.push({cell: COLUMNS[COLUMNS.indexOf(squareLetter)+1] + squareNumber, direction: 'right'});
    }
    if (squareNumber > 1) {
      neighbours.push({cell: squareLetter + (squareNumber-1), direction: 'bottom'});
    }
    if (squareNumber < 8) {
      neighbours.push({cell: squareLetter + (squareNumber+1), direction: 'top'});
    }
    
    return neighbours;
  }

  initializeWalls() {
    SQUARE_WALLS = {};
    var direction, wS;
    
    Object.keys(this.props.walls).forEach((wall) => {
      var [cell1, cell2] = wall.split('-');
      direction = this.determineDirection(cell1, cell2);
      if (!SQUARE_WALLS[cell1]) {
        SQUARE_WALLS[cell1] = {};
      }
      if (!SQUARE_WALLS[cell2]) {
        SQUARE_WALLS[cell2] = {};
      }
      wS = this.props.wallStyle[this.props.walls[wall]];
      var style = `${wS.size}px ${wS.style} ${wS.color}`
      SQUARE_WALLS[cell1][direction] = style;
      SQUARE_WALLS[cell2][this.oppositeDirection(direction)] = style;
    });
  }

  calculateCurveParams(width, height, curveSpace, x1, x2, y1, y2, type = 'curved-top') {
    var angle  = Math.atan2(y2 - y1, x2 - x1);
    var controlX = Math.abs(Math.floor(width*Math.cos(angle)/2)) - Math.abs(curveSpace*Math.sin(angle))+10;
    var controlY = Math.abs(Math.floor(height*Math.sin(angle)/2)) - Math.abs(curveSpace*Math.cos(angle))+10;
    if (type === 'curved-bottom') {
      controlY *= -2;
    } else if (type === 'curved-left') {
      controlX = 0;
    } else if (type === 'curved-right') {
      controlX = Math.abs(controlX)+10;
    }
    var headAngle = Math.atan2(y2 - controlY, x2 - controlX);
    return [
      angle,
      controlX,
      controlY,
      headAngle
    ]
  }
}


// WEBPACK FOOTER //
// ./src/ChessBoard.js